export default function useArticle() {
    /**
     * Splits a string into an array using multiple separators, preserving the separators as separate elements.
     *
     * @param {string} text - The input string to split.
     * @param {string[]} separators - An array of separator strings to split the text by.
     * @returns {string[]} An array of substrings and separators, with empty strings removed.
     */
    const splitWithSeparators = (text, separators) => {
        if (!text || separators.length === 0) return [text];

        const escapedSeparators = separators.map((sep) =>
            sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        );
        const regex = new RegExp(`(${escapedSeparators.join('|')})`);

        return text.split(regex).filter((part) => part !== '');
    };

    /**
     * Helper function to process article content
     * - Adds `target='_blank'` to all `<a>` tags.
     * - Removes `srcset` and `sizes` attributes from `<img>` tags for consistency.
     */
    const replaceContent = (data) => {
        // Add target='_blank' to all href links
        let content = data.replace(
            /href/g,
            'target="_blank" rel="noopener noreferrer" href'
        );

        // Use a regular expression to find all <img> tags and replace them
        content = content.replace(/<img[^>]+>/g, (imgTag) => {
            // Remove srcset and sizes attributes
            const newImgTag = imgTag
                .replace(/\s+srcset="[^"]*"/g, '')
                .replace(/\s+sizes="[^"]*"/g, '');
            return newImgTag;
        });

        return content;
    };

    return { splitWithSeparators, replaceContent };
}
